import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeBullet',
    standalone: false
})
export class RemoveBulletPipe implements PipeTransform {
  transform(value: string): string {
    return value?.replace('\\u2022', '\u2022').trim();
  }
}
